export default {
	tenantId: "yallacompare_prod",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "yallacompare--prod"
	}
}
